import { RouterModule, Routes } from '@angular/router';
import { RxIELoadGuard } from '@nrwl/rx-ie-detection';
import { AuthGuard } from '@nrwl/rx-service-auth';
import { NgModule } from '@angular/core';
import { LogoutComponent } from './core/components/logout/logout.component';

const routes: Routes = [
  {
    path: 'administration',
    loadChildren: () => import('./admin/administration.module').then((m) => m.AdministrationModule),
    data: { title: 'Administration' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'doctor-consultation',
    loadChildren: () => import('./doctor/doctor.module').then((m) => m.DoctorModule),
  },
  {
    path: 'clients',
    loadChildren: () => import('./clients/clients.module').then((m) => m.ClientsModule),
    data: { title: 'Clients' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'galleries',
    loadChildren: () => import('./galleries/galleries.module').then((m) => m.GalleriesModule),
    data: { title: 'Galleries' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'leads',
    loadChildren: () => import('./leads/leads.module').then((m) => m.LeadsModule),
    data: { title: 'Leads' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'user-setting',
    loadChildren: () =>
      import('./user-setting/user-setting.module').then((m) => m.UserSettingModule),
    data: { title: 'User-setting' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'payment',
    loadChildren: () => import('./payment/payment.module').then((m) => m.PaymentModule),
    data: { title: 'Payment' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'browser-notification',
    loadChildren: () => import('@nrwl/rx-ie-detection').then((m) => m.RxIEDetectionModule),
  },
  {
    path: 'static',
    loadChildren: () =>
      import('./static-pages/static-pages.module').then((m) => m.StaticPagesModule),
  },
  {
    path: 'client-photos',
    loadChildren: () =>
      import('./client-photos/client-photos.module').then((m) => m.ClientPhotosModule),
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'patient',
    loadChildren: () =>
      import('./clients/patient-record/patient-record.module').then((m) => m.PatientRecordModule),
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'inbox',
    loadChildren: () => import('./inbox/inbox.module').then((m) => m.InboxModule),
    data: { title: 'Inbox' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'personalized-plans',
    loadChildren: () =>
      import('./personalized-plans/plan-customization.routes').then(
        (m) => m.PLAN_CUSTOMIZATION_ROUTES,
      ),
    data: { title: 'Personalized Plans' },
    canLoad: [AuthGuard, RxIELoadGuard],
  },
  {
    path: 'impersonate',
    loadChildren: () => import('./impersonate/impersonate.module').then((m) => m.ImpersonateModule),
    data: { title: 'Impersonate' },
  },
  {
    path: '',
    redirectTo: 'clients',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
